"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EngageEpic = void 0;
var _reduxObservable = require("redux-observable");
var _operators = require("rxjs/operators");
var _types = require("../game/types");
var _rxjs = require("rxjs");
var _types2 = require("../balance/types");
var _engageService = require("../../../utils/engageService");
var _types3 = require("../ui/types");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EngageEpic = exports.EngageEpic = /*#__PURE__*/function () {
  function EngageEpic() {
    var _this = this;
    _classCallCheck(this, EngageEpic);
    _defineProperty(this, "engageService", void 0);
    _defineProperty(this, "listen", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.GAME_READY, _types2.UPDATE_BALANCE, _types.ROUND_START, _types.ROUND_END, _types.EXIT, _types3.DIALOG_STATE, _types3.DIALOG_CANCEL, _types3.DIALOG_EXIT, _types3.DIALOG_OK, _types3.DIALOG_CLOSE), (0, _operators.mergeMap)(function (a) {
        _this.engageService.post(a.type, a.payload);
        return _rxjs.EMPTY;
      }));
    });
    this.engageService = new _engageService.EngageService();
  }
  return _createClass(EngageEpic, [{
    key: "getEpic",
    value: function getEpic() {
      return (0, _reduxObservable.combineEpics)(this.listen);
    }
  }]);
}();
//# sourceMappingURL=epics.js.map